import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-black mt-10 bg-white" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-4 py-4 text-[12px] text-[#555] flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span>TerminalValue.io</span>
          <span className="text-[#bbb]">·</span>
          <span>the investing tools index</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/submit" className="tv-link" data-testid="footer-submit">submit</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/best" className="tv-link" data-testid="footer-best">best lists</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/about" className="tv-link" data-testid="footer-about">about</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/contact" className="tv-link" data-testid="footer-contact">contact</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/sitemap" className="tv-link" data-testid="footer-sitemap">sitemap</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/tickers" className="tv-link" data-testid="footer-tickers">tickers</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/terms" className="tv-link" data-testid="footer-terms">terms</Link>
          <span className="text-[#bbb]">·</span>
          <Link to="/privacy" className="tv-link" data-testid="footer-privacy">privacy</Link>
        </div>
      </div>
      {/* FTC-style affiliate disclosure surfaced beyond the Terms page.
          Required to be conspicuous on any page where a click could earn
          a commission. Compact, dim, single line, brutalist. */}
      <div
        className="border-t border-[#f0f0f0] max-w-5xl mx-auto px-4 py-1.5 text-[10px] text-[#aaa]"
        data-testid="affiliate-disclosure"
      >
        Affiliate disclosure: some outbound links may earn us a commission at no
        cost to you ·{" "}
        <Link to="/terms#affiliate-disclosure" className="tv-link">
          terms §12
        </Link>
      </div>
    </footer>
  );
}
